import { createNamespacedHelpers } from 'vuex'
const { mapMutations } = createNamespacedHelpers('setting')

export default {
  methods: {
    ...mapMutations(['setDisplayHeader'])
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      const displayHeader = vm.displayHeader
      vm.setDisplayHeader(displayHeader)
    })
  }
}
